import {
  Autocomplete,
  Box,
  Button,
  Grid,
  IconButton,
  styled,
  Switch,
  Tooltip,
  Typography,
} from "@mui/material";
import React from "react";
import MainCard from "../../components/Maincard";
import { useGetTokenOrLogout } from "../../utils/token";
import { useState } from "react";
import { useEffect } from "react";

import HeadingCard from "../../newTestPrep/newComponent/NewCardsComp/HeadingCard";
import { DataGrid } from "@mui/x-data-grid";
import CustomNoRowsOverlay from "../../newTestPrep/newComponent/TableCustomeComp/CustomNoRowsOverlay";
import CreateAutoAssignForm from "./CreateAutoAssignForm";
import LoaderComp from "../../newTestPrep/newComponent/LoaderComp/Loader";
import EditIconcomp from "../../newTestPrep/newComponent/iconsComp/EditIconcomp";
import EditAutoAssign from "./EditAutoAssign";
import CustomPopup from "../../components/CustomPopup";
import SearchTextFieldComp from "../../newTestPrep/newComponent/newtextfieldComp/SearchTextFieldComp";
import AllBranches from "../../newTestPrep/pages/Campaign/AllBranches";
import AddButton from "../../newTestPrep/newComponent/NewButtonComp/AddButton";
import AddAutoAssign from "./AddAutoAssign";
import { fDate } from "../../utils/formatTime";
import { is } from "date-fns/locale";
import CustomSnackbar from "../../newTestPrep/components/ui-component/snackbar/CustomSnackbar";
import { set } from "date-fns";
const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

export default function AutoAssignLeads() {
  const userId = localStorage.getItem("userId");
  const userRole = localStorage.getItem("userRole");  
  
  const getTokenOrLogout = useGetTokenOrLogout();

  const [autoAssignLeads, setAutoAssignLeads] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [checkedState, setCheckedState] = useState({});
  const [openEditPopup, setOpenEditPopup] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [viewMorePopup, setViewMorePopup] = useState(false);
  const [selectedColumnTitle, setSelectedColumnTitle] = useState(null);
  const [remainingData, setRemainingData] = useState([]);
  const [openAddPopup, setOpenAddPopup] = useState(false);
  const [checkedFilterState, setCheckedFilterState] = useState(true);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  // Show snackbar
  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };
  const handleOpenAddPopup = () => {
    setOpenAddPopup(true);
  };

  const handleCloseAddPopup = () => {
    setOpenAddPopup(false);
  };

  const handleOpenViewMorePopup = (row, title) => {
    setRemainingData(row);
    setViewMorePopup(true);
    setSelectedColumnTitle(title);
  };

  const handleCloseViewMorePopup = () => {
    setRemainingData([]);
    setViewMorePopup(false);
  };

  const columns = [
    {
      field: "action",
      headerName: "Action",
      width: 100,
      sortable: false,
      disableColumnMenu: true,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            {userRole==="data_entry" && ( 
              <>
            {params?.row?.is_active === 1 && (
              <EditIconcomp
                onClick={() => handleOpenEditPopup(params?.row)}
                fontSize="1rem"
                tooltipTitle="Edit"
              />
            )}
            <Tooltip
              title={
                params?.row?.is_active === 0 ? "Make Active" : "Make Inactive"
              }
            >
              <Switch
                checked={!!checkedState[params?.row.id]}
                onChange={(event) =>
                  handleSwitchChange(event, params?.row.id, params?.row)
                }
                size="small"
                color="secondary"
                sx={{
                  "& .MuiSwitch-switchBase": {
                    padding: 1,
                    height: 1,
                  },
                  "& .MuiSwitch-thumb": {
                    width: 12, // Thumb size
                    height: 12,
                    background: checkedState[params?.row.id]
                      ? "#00b13f"
                      : "#f44336", // Green when active, Red when inactive
                  },
                  "& .MuiSwitch-track": {
                    backgroundColor: checkedState[params?.row.id]
                      ? "#e0f7e0"
                      : "#ff9fad", // Light green for active, light red for inactive
                    opacity: 1, // Ensure visibility
                  },
                }}
              />
            </Tooltip>{" "}

</>
            )}
          </div>
        );
      },
    },

    {
      field: "campaign_name",
      headerName: "Campaign Name",
      width: 150,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => params.row?.campaign_id?.campaign_name,
      renderCell: (params) => (
        <div> {params.row?.campaign_id?.campaign_name}</div>
      ),
    },
    {
      field: "service_name",
      headerName: "Service Name",
      width: 200,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",

      // renderCell: (params) => (
      //   <div>{params?.row?.service_id?.map((item) => item).join(", ")}</div>
      // ),

      renderCell: (params) => {
        const services = params?.row?.service_id || [];
        const visibleCount = 1; // Set the number of visible branches
        const visibleService = services.slice(0, visibleCount);
        const extraService = services.slice(visibleCount);

        return (
          <>
            {visibleService.map((service, index) => (
              <div key={index}>{service}</div>
            ))}
            {extraService?.length > 0 && (
              <Typography
                variant="h6"
                style={{
                  cursor: "pointer",
                  marginLeft: "7px",
                  color: "#46b1ff",
                }}
                onClick={() =>
                  handleOpenViewMorePopup(extraService, "Remaining Services")
                }
              >
                +{extraService?.length}
              </Typography>
            )}
          </>
        );
      },
    },
    {
      field: "sub_service_name",
      headerName: "Sub Service Name",
      width: 250,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      // renderCell: (params) => (
      //   <div>{params?.row?.sub_service_id?.map((item) => item).join(", ")}</div>
      // ),

      renderCell: (params) => {
        const subServices = params?.row?.sub_service_id || [];
        const visibleCount = 1; // Set the number of visible branches
        const visibleSubService = subServices.slice(0, visibleCount);
        const extraSubService = subServices.slice(visibleCount);

        return (
          <>
            {visibleSubService.map((subServices, index) => (
              <div key={index}>{subServices}</div>
            ))}
            {extraSubService?.length > 0 && (
              <Typography
                variant="h6"
                style={{
                  cursor: "pointer",
                  marginLeft: "7px",
                  color: "#46b1ff",
                }}
                onClick={() =>
                  handleOpenViewMorePopup(
                    extraSubService,
                    "Remaining Sub Services",
                  )
                }
              >
                {`+${extraSubService?.length}`}
              </Typography>
            )}
          </>
        );
      },
    },
    {
      field: "program_name",
      headerName: "Program Name",
      width: 200,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      // renderCell: (params) => (
      //   <div>
      //     {" "}
      //     {params?.row?.admission_program_id?.map((item) => item).join(", ")}
      //   </div>
      // ),
      renderCell: (params) => {
        const admissionPrograms = params?.row?.admission_program_id || [];
        const visibleCount = 1; // Set the number of visible branches
        const visibleAdmissionPrograms = admissionPrograms.slice(
          0,
          visibleCount,
        );
        const extraAdmissionPrograms = admissionPrograms.slice(visibleCount);

        return (
          <>
            {visibleAdmissionPrograms.map((admissionPrograms, index) => (
              <div key={index}>{admissionPrograms}</div>
            ))}
            {extraAdmissionPrograms?.length > 0 && (
              <Typography
                variant="h6"
                style={{
                  cursor: "pointer",
                  marginLeft: "7px",
                  color: "#46b1ff",
                }}
                onClick={() =>
                  handleOpenViewMorePopup(
                    extraAdmissionPrograms,
                    "Remaining Programs",
                  )
                }
              >
                {`+${extraAdmissionPrograms?.length}`}
              </Typography>
            )}
          </>
        );
      },
    },
    {
      field: "nearest_branch",
      headerName: "Nearest Branch",
      width: 200,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",

      // renderCell: (params) => (
      //   <div>
      //     {params?.row?.nearest_branch_id?.map((item) => item).join(", ")}
      //   </div>
      // ),

      renderCell: (params) => {
        const branches = params?.row?.nearest_branch_id || [];
        const visibleCount = 1; // Set the number of visible branches
        const visibleBranches = branches.slice(0, visibleCount);
        const extraBranches = branches.slice(visibleCount);

        return (
          <>
            {visibleBranches.map((branches, index) => (
              <div key={index}>{branches}</div>
            ))}
            {extraBranches?.length > 0 && (
              <Typography
                variant="h6"
                style={{
                  cursor: "pointer",
                  marginLeft: "7px",
                  color: "#46b1ff",
                }}
                onClick={() =>
                  handleOpenViewMorePopup(extraBranches, "Remaining Branches")
                }
              >
                {`+${extraBranches?.length}`}
              </Typography>
            )}
          </>
        );
      },
    },
    {
      field: "total_lead",
      headerName: "Total Lead",
      width: 100,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => <div> {params.row?.total_assigned}</div>,
    },
    {
      field: "user_name",
      headerName: "User Assigned Percentage",
      width: 200,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <div style={{ lineHeight: "1.5" }}>
          {params?.row?.assignment_percentage?.map((item, index) => (
            <div key={index}>
              <strong>{item?.user_id?.first_name}</strong> → {item?.per}%
              <span style={{ color: "#777" }}>
                {" "}
                (Assigned: {item?.assigned})
              </span>
            </div>
          ))}
        </div>
      ),
    },

    {
      field: "created_at",
      headerName: "Created Date",
      width: 100,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => <div>{fDate(params?.row?.createdAt)}</div>,
    },

    {
      field: "created_by",
      headerName: "Created By",
      width: 100,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <div>
          {params?.row?.created_by?.first_name}{" "}
          {params?.row?.created_by?.last_name}
        </div>
      ),
    },

    {
      field: "updated_at",
      headerName: "Updated Date",
      width: 100,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => <div>{fDate(params?.row?.updatedAt)}</div>,
    },

    {
      field: "updated_by",
      headerName: "Updated By",
      width: 100,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <div>
          {params?.row?.updated_by?.first_name}{" "}
          {params?.row?.updated_by?.last_name}
        </div>
      ),
    },
  ];

  // useEffect(() => {
  //   setLoading(true);
  //   const getAutoAssignLeads = async () => {
  //     try {
  //       const response = await fetch(
  //         `${API_ENDPOINT}leaddistribution/user/${userId}`,
  //         {
  //           method: "GET",
  //           headers: {
  //             "Content-Type": "application/json",
  //             Authorization: `Bearer ${getTokenOrLogout()}`,
  //           },
  //         },
  //       );
  //       const data = await response.json();
  //       setAutoAssignLeads(data?.data);
  //       setSearchData(data?.data);

  //       // Initialize switch state
  //       const switchState = {};
  //       data?.data?.forEach((item) => {
  //         switchState[item.id] = item.is_active === 1;
  //       });

  //       setCheckedState(switchState);
  //       setLoading(false);
  //     } catch (error) {
  //       console.error("Error fetching leads:", error);
  //       setLoading(false);
  //     }
  //   };
  //   getAutoAssignLeads();
  // }, []);

  const handleSwitchChange = async (event, id, row) => {
    const newStatus = event.target.checked ? 1 : 0;

    try {
      const response = await fetch(
        `${API_ENDPOINT}leaddistribution/active-inactive`,
        {
          method: "POST", // or PATCH (depends on backend)
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getTokenOrLogout()}`,
          },
          body: JSON.stringify({
            lead_distribution_id: id,
            user_id: parseInt(userId),
          }),
        },
      );

      const result = await response.json();

      if (response.ok) {
        // Update UI after success
        setCheckedState((prev) => ({
          ...prev,
          [id]: newStatus === 1,
        }));

        setAutoAssignLeads((prev) =>
          prev?.map((item) =>
            item.id === id ? { ...item, is_active: newStatus } : item,
          ),
        );

        showSnackbar("Status updated successfully", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        console.error("Update failed:", result.message);
        showSnackbar(result.message, "error");
      }
    } catch (error) {
      console.error("Status update error:", error);
      showSnackbar("Status update error", "error");
    }
  };

  const handleOpenEditPopup = (row) => {
    setOpenEditPopup(true);
    setSelectedRow(row);
  };

  const handleCloseEditPopup = () => {
    setOpenEditPopup(false);
  };

  // Search

  const handleSearchByName = (e) => {
    const value = e.target.value.toLowerCase().replace(/\s+/g, ""); // Normalize search value (lowercase and remove spaces)

    let filteredData1 = searchData.filter((data) => {
      // Check each field for a match with the search value
      const fieldsToSearch = [
        `${data?.campaign_id?.campaign_name || ""}`,
        `${data?.admission_program_id?.map((item) => item).join(", ") || ""}`,
        `${data?.nearest_branch_id?.map((item) => item).join(", ") || ""}`,
        `${data?.service_id?.map((item) => item).join(", ") || ""}`,
        `${data?.sub_service_id?.map((item) => item).join(", ") || ""}`,
        `${data?.counsellor_id?.map((item) => item).join(", ") || ""}`,
        `${data?.created_by?.first_name || ""}${
          data?.created_by?.last_name || ""
        }`,
        `${data?.updated_by?.first_name || ""}${
          data?.updated_by?.last_name || ""
        }`,
        `${fDate(data?.createdAt || "") }`,
        `${fDate(data?.updatedAt || "")}`,
        `${data?.assignment_percentage?.map((item) => item?.user_id?.first_name).join(", ") || ""}`,
      ];

      // Check if any of the fields contain the search value
      return fieldsToSearch.some((field) =>
        field.toLowerCase().replace(/\s+/g, "").includes(value),
      );
    });

    setAutoAssignLeads(filteredData1); // Update the filtered data
  };

  const handleFilter = async (event) => {
    setLoading(true);

    try {
      const response = await fetch(
        `${API_ENDPOINT}leaddistribution/fetch-data`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getTokenOrLogout()}`,
          },
          body: JSON.stringify({
            user_id: parseInt(userId),
            is_active: checkedFilterState ? 1 : 0,
          }),
        },
      );

      const result = await response.json();

      console.log("result", result);

      if (result.status === 200) {
        setAutoAssignLeads(result?.data);
        setSearchData(result?.data);
        const switchState = {};
        result?.data?.forEach((item) => {
          switchState[item.id] = item.is_active === 1;
        });

        setCheckedState(switchState);
      } else {
        showSnackbar(`Error: ${result.message}`, "error");
      }
    } catch (error) {
      showSnackbar(`Error: ${error.message}`, "error");
    } finally {
      setLoading(false); // always stop loading
    }
  };

  useEffect(() => {
    if (userId) {
      handleFilter();
    }
  }, [checkedFilterState, userId]);

  const handleFilterSwitchChange = (event) => {
    setCheckedFilterState(event.target.checked);
  };

  return (
    <>
      <LoaderComp isLoading={loading} />
      <Grid container spacing={2}>
        <Grid item xs={12} md={3} sm={4} lg={2.5}>
          <HeadingCard label="Lead Assignment" />
        </Grid>

{
  userRole.includes("data_entry") && (
 <Grid item xs={12} md={9} sm={8} lg={9.5} textAlign="right">
          <AddButton
            label="Add Lead Assignment"
            size="medium"
            onClick={handleOpenAddPopup}
          />
        </Grid>

  )
}
       
        {/* <Grid item xs={12}>
          <CreateAutoAssignForm />
        </Grid> */}

        <Grid item xs={12}>
          <MainCard>
            <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                sm={6}
                container
                alignItems="center"
                direction="row"
              >
                <Typography variant="h4" color="error">
                  InActive
                </Typography>
                <Switch
                  checked={checkedFilterState}
                  onChange={handleFilterSwitchChange}
                  color="secondary"
                  sx={{
                    "& .MuiSwitch-thumb": {
                      background: checkedFilterState ? "#00b13f" : "#f44336", // Green when active, Red when inactive
                    },
                    "& .MuiSwitch-track": {
                      backgroundColor: checkedFilterState
                        ? "#e0f7e0"
                        : "#ff9fad", // Light green for active, light red for inactive
                      opacity: 1, // Ensure visibility
                    },
                  }}
                />
                <Typography variant="h4" color="#00b13f">
                  Active
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} textAlign="right">
                <SearchTextFieldComp onChange={handleSearchByName} />
              </Grid>

              <Grid item xs={12}>
                <DataGrid
                  disableColumnMenu
                  rows={autoAssignLeads}
                  columns={columns}
                  getRowHeight={() => "auto"}
                  slots={{
                    noRowsOverlay: () => (
                      <CustomNoRowsOverlay message="No Data Available" />
                    ),
                  }}
                  autoHeight
                  initialState={{
                    pagination: {
                      paginationModel: {
                        pageSize: 25,
                      },
                    },
                  }}
                  pageSizeOptions={[25, 50, 100]}
                />
              </Grid>
            </Grid>
          </MainCard>
        </Grid>
      </Grid>

      <CustomPopup
        open={openEditPopup}
        onClose={handleCloseEditPopup}
        title="Edit Auto Assign Lead"
        component={
          <EditAutoAssign
            onClose={handleCloseEditPopup}
            selectedRow={selectedRow}
          />
        }
        maxWidth="sm"
        showDivider={true}
      />

      <CustomPopup
        open={viewMorePopup}
        onClose={handleCloseViewMorePopup}
        component={
          <AllBranches
            onClose={handleCloseViewMorePopup}
            selectedbranhes={remainingData}
          />
        }
        title={selectedColumnTitle}
        showDivider="true"
        maxWidth="xs"
      />

      <CustomPopup
        open={openAddPopup}
        onClose={handleCloseAddPopup}
        component={<AddAutoAssign onClose={handleCloseAddPopup} />}
        title="Add Auto Assign Lead"
        showDivider="true"
        maxWidth="sm"
      />

      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </>
  );
}
